import { Injectable } from '@angular/core';
import { CUSTOMER_TYPE, EMAIL_POPUP, ICON_PATH_KEY } from '@app/core/constants/app.enum';
import { STORAGE_CONST } from '@app/core/constants/storage-constants';
import { EmailPrintingComponent } from '@app/shared/components/email-printing/email-printing.component';
import { AdvancedEmailAliasData, COMBINATION_TYPE } from '@app/shared/models/LocationData';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavigationBar } from '@capgo/capacitor-navigation-bar';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../alert/alert.service';
import { DomainService } from '../domain/domain.service';
import { SharedService } from '../shared/shared.service';
import { StorageService } from '../storage/storage.service';
import { NAV_BAR_COLOR } from '@app/core/constants/app-constant';
@Injectable({
  providedIn: 'root',
})
export class AppHelperService {
  constructor(
    private sharedSvc: SharedService,
    private translateService: TranslateService,
    private alertSvc: AlertService,
    private modalController: ModalController,
    private navCtrl: NavController,
    private storage: StorageService,
    private domainSvc: DomainService
  ) {}

  icon(file, key: ICON_PATH_KEY): string {
    if (
      (key !== ICON_PATH_KEY.folder && file[key] === 'folder') ||
      (key === ICON_PATH_KEY.folder && file.folder)
    ) {
      return '/assets/icon/folder.svg';
    }
    const fileExt = file.name.split('.').pop();
    switch (fileExt.toLowerCase()) {
      case 'zip':
        return '/assets/icon/png-icons/zip.png';
      case 'heic':
        return '/assets/icon/png-icons/heic.png';
      case 'xps':
        return '/assets/icon/png-icons/xps.png';
      case 'xlsx':
        return '/assets/icon/png-icons/xlsx.png';
      case 'xls':
        return '/assets/icon/png-icons/xls.png';
      case 'txt':
        return '/assets/icon/png-icons/txt.png';
      case 'tiff':
        return '/assets/icon/png-icons/tiff.png';
      case 'tif':
        return '/assets/icon/png-icons/tif.png';
      case 'rtf':
        return '/assets/icon/png-icons/rtf.png';
      case 'pptx':
        return '/assets/icon/png-icons/pptx.png';
      case 'ppt':
        return '/assets/icon/png-icons/ppt.png';
      case 'png':
        return '/assets/icon/png-icons/png.png';
      case 'pdf':
        return '/assets/icon/png-icons/pdf.png';
      case 'odt':
        return '/assets/icon/png-icons/odt.png';
      case 'ods':
        return '/assets/icon/png-icons/ods.png';
      case 'odp':
        return '/assets/icon/png-icons/odp.png';
      case 'jpg':
        return '/assets/icon/png-icons/jpg.png';
      case 'jpeg':
        return '/assets/icon/png-icons/jpeg.png';
      case 'html':
        return '/assets/icon/png-icons/html.png';
      case 'htm':
        return '/assets/icon/png-icons/htm.png';
      case 'gif':
        return '/assets/icon/png-icons/gif.png';
      case 'docx':
        return '/assets/icon/png-icons/docx.png';
      case 'doc':
        return '/assets/icon/png-icons/doc.png';
      case 'bmp':
        return '/assets/icon/png-icons/bmp.png';
      default:
        return '/assets/icon/png-icons/default-file.png';
    }
  }

  async emailPopup(val: EMAIL_POPUP) {
    const customerDetails = this.sharedSvc.getCustomerDetails;

    if (customerDetails) {
      const { HowToLogoSection: howLogoSection } = customerDetails.customizationsText;
      const { CustomerType } = customerDetails.customerData;
      const domainDetail = await this.sharedSvc.getDomainInfo();
      const selectedLocation = customerDetails.locations.find(
        (loc) => loc?._id === domainDetail?.locationId
      );

      let bwEmail = '';
      let colorEmail = '';
      let email = '';
      let aliasEmail = '';
      let advanceEmailString = '';

      if (
        (selectedLocation?.AdvancedEmails?.AdvancedEmailAlias?.length || 0) > 0 &&
        selectedLocation?.AdvancedEmails?.Enabled
      ) {
        selectedLocation?.AdvancedEmails?.AdvancedEmailAlias.forEach((email) => {
          if (email) {
            advanceEmailString += this.getAdvancedEmailString(email);
          }
        });
      } else if (CustomerType === CUSTOMER_TYPE.tbs) {
        bwEmail =
          howLogoSection.EmailAddressAssignedGrayscaleAlias ||
          howLogoSection.EmailAddressAssignedGrayscale;
        colorEmail =
          howLogoSection.EmailAddressAssignedColorAlias || howLogoSection.EmailAddressAssignedColor;
      } else {
        email = howLogoSection.EmailAddressAssignedCustomer;
        aliasEmail = howLogoSection.EmailAddressAssignedCustomerAlias;
        val = aliasEmail ? EMAIL_POPUP.nonTbsAliasEmailPrinting : EMAIL_POPUP.nonTbsEmailPrinting;
      }

      const createEmailContent = (header: string, content: string) =>
        `${this.translateService.instant('OTHER_EMAIL_STARTING_STRING')}:
         <br><br>${header}: 
         <a href="mailto:${content}" class="text-blue-700">${content}</a>
         <br><br>${this.translateService.instant('OTHER_EMAIL_SUB_STRING')}`;

      let message = '';

      switch (val) {
        case EMAIL_POPUP.emailPrinting:
          message = `${this.translateService.instant('OTHER_EMAIL_STARTING_STRING')}:
            ${
              advanceEmailString
                ? advanceEmailString
                : !bwEmail && !colorEmail
                ? `<br><br><b>${this.translateService.instant('EMAIL_PRINTING_NOT_AVAILABLE')}</b>`
                : `${
                    bwEmail
                      ? `<br><br>B&W ${this.translateService.instant('PRINTER')}: 
             <a href="mailto:${bwEmail}" class="text-blue-700">${bwEmail}</a>`
                      : ''
                  }
             ${
               colorEmail
                 ? `<br><br>${this.translateService.instant('COLOR_PRINTER')}: 
             <a href="mailto:${colorEmail}" class="text-blue-700">${colorEmail}</a>`
                 : ''
             }`
            }
             <br><br>${this.translateService.instant('OTHER_EMAIL_SUB_STRING')}`;
          break;
        case EMAIL_POPUP.nonTbsEmailPrinting:
          message = createEmailContent('Email', email);
          break;
        case EMAIL_POPUP.nonTbsAliasEmailPrinting:
          message = createEmailContent('Alias Email', aliasEmail);
          break;
        default:
          break;
      }
      const modal = await this.modalController.create({
        component: EmailPrintingComponent,
        componentProps: {
          message,
        },
        cssClass: 'email-printing-modal',
      });
      await modal.present();
    } else {
      if (await this.alertSvc.emailPrintingAlert()) {
        this.navCtrl.navigateForward('app/add-files/maps', { state: { showMenu: false } });
      }
    }
  }

  getAdvancedEmailString(emailData: AdvancedEmailAliasData) {
    if (!emailData?.Email) {
      return '';
    }
    let emailString = '';
    if (emailData?.CombinationType?.includes(COMBINATION_TYPE.color_onesided)) {
      emailString = `<br><br>${this.translateService.instant('COLOR_1SIDED_PRINTER')}:
        <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
      return emailString;
    } else if (emailData?.CombinationType?.includes(COMBINATION_TYPE.bw_onesided)) {
      emailString = `<br><br>${this.translateService.instant('BW_1SIDED_PRINTER')}:
        <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
      return emailString;
    } else if (emailData?.CombinationType?.includes(COMBINATION_TYPE.color_twosided)) {
      emailString = `<br><br>${this.translateService.instant('COLOR_2SIDED_PRINTER')}:
        <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
      return emailString;
    } else if (emailData?.CombinationType?.includes(COMBINATION_TYPE.bw_twosided)) {
      emailString = `<br><br>${this.translateService.instant('BW_2SIDED_PRINTER')}:
        <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
      return emailString;
    } else {
      switch (emailData?.CombinationType) {
        case COMBINATION_TYPE.default:
          emailString = `<br><br>${this.translateService.instant('PRINTER')}:
           <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
          break;
        case COMBINATION_TYPE.color:
          emailString = `<br><br>${this.translateService.instant('COLOR_PRINTER')}:
         <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
          break;
        case COMBINATION_TYPE.bw:
          emailString = `<br><br>B&W ${this.translateService.instant('PRINTER')}:
         <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
          break;
        // case COMBINATION_TYPE.color_onesided:
        //   emailString = `<br><br>${this.translateService.instant('COLOR_1SIDED_PRINTER')}:
        //  <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
        //   break;
        // case COMBINATION_TYPE.color_twosided:
        //   emailString = `<br><br>${this.translateService.instant('COLOR_2SIDED_PRINTER')}:
        //  <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
        //   break;
        // case COMBINATION_TYPE.bw_onesided:
        //   emailString = `<br><br>${this.translateService.instant('BW_1SIDED_PRINTER')}:
        //  <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
        //   break;
        // case COMBINATION_TYPE.bw_twosided:
        //   emailString = `<br><br>${this.translateService.instant('BW_2SIDED_PRINTER')}:
        //  <a href="mailto:${emailData.Email}" class="text-blue-700">${emailData.Email}</a>`;
        //   break;
        default:
          break;
      }
    }
    return emailString;
  }

  async handleStatusBar() {
    try {
      const domainInfo = await this.storage.getJson(STORAGE_CONST.DOMAIN_INFO);
      const result = domainInfo?.domainname ? await this.domainSvc.domainDetails(domainInfo.domainname) : null;
      const primaryColor = result?.customizations?.Hex500 || '#172d51';
      const r = document.querySelector(':root');
      r['style'].setProperty('--ion-color-eprintprimary', '' + primaryColor);
      if (Capacitor.isNativePlatform()) {
        StatusBar.setStyle({ style: Style.Dark });
        if (Capacitor.getPlatform() === 'android') {
          try {
            await NavigationBar.setNavigationBarColor({ color: NAV_BAR_COLOR, darkButtons: true });
          } catch (error) {
            console.log('🚀 ~ handleStatusBar ~ NavigationBar error:', error);
          }
        }
        setTimeout(async () => {
          await StatusBar.setBackgroundColor({ color: primaryColor });
        }, 200); // On some devices setting status bar color immediately doesn't work
      }
    } catch (error) {
      console.log('🚀 ~ handleStatusBar ~ error:', error);
    }
  }
}
